{
  "page_title": "Подключение MCP",
  "requests_access": "Разрешить приложению {clientName} доступ к %APP_NAME%?",
  "requests_access_description": "Приложение сможет работать с данными вашей организации в пределах ваших прав доступа.",
  "scope_mcp_read": "Просматривать доступные вам данные сотрудников, отпусков и целей",
  "scope_mcp_write": "Создавать и изменять доступные вам данные",
  "scope_unknown": "Дополнительное разрешение: {scope}",
  "scopes_hint": "Снятый доступ приложение получит только при повторном подключении.",
  "allow": "Разрешить",
  "deny": "Не разрешать",
  "loading": "Загрузка…",
  "error_title": "Ошибка авторизации",
  "generic_error": "Что-то пошло не так. Попробуйте ещё раз.",
  "error_invalid_scope": "Приложение запросило разрешения, которые ему недоступны.",
  "error_invalid_client": "Неизвестное или отключённое приложение. Подключите его заново и повторите попытку.",
  "error_invalid_request": "Запрос авторизации составлен неверно (адрес возврата или параметры). Начните подключение из приложения заново."
}
